import React, { useEffect, useState } from "react";
import AnimatedHeroSection from "../sections/BusinessSupport/AnimatedHeroSection";
import WhyTradesPoster from "../sections/BusinessSupport/WhyTradesPoster";
import Banner from "../components/common/Banners/Banner";
import MainButton from "../components/common/MainButton/MainButton";
import Login from "../sections/Login/Login";
import { SignUp as SignUpRegister } from "../sections/SignUp/SignUp";
import HelpSupport from "../sections/CustomerSupport/HelpSupport";
import MessagingSystemLayout from "../sections/BusinessSupport/MessagingSystemLayout";
import UsageGuide from "../sections/BusinessSupport/UsageGuide";
import BusinessPortfolio from "../sections/BusinessSupport/BusinessPortfolio";
import Stories from "../sections/BusinessSupport/Stories";
import FullLengthSlider from "../sections/AllServicesSlider/FullLengthSlider";
import BusinessSupportFAQs from "../components/common/PricingFAQs/BusinessSupportFAQs";
import {
  PUBLIC_SECTION_GAP_CLASS,
  PUBLIC_BROWSE_SLIDER_ITEM_GAP_CLASS,
  PUBLIC_SLIDER_IMAGE_TO_LABEL_CLASS,
} from "../sections/Public/shared/publicLayoutSpec";

const BusinessSupport = () => {
  const [SignUp, setSignUp] = useState(false);
  const [SignIn, setSignIn] = useState(false);

  useEffect(() => {
    if (SignUp) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "visible";
      document.body.style.width = `auto`;
    }
  }, [SignUp]);

  return (
    <>
      <AnimatedHeroSection />
      <WhyTradesPoster />
      {/* <UsageGuide /> */}
      <MessagingSystemLayout />
      {/* <BusinessPortfolio /> */}
      <BusinessSupportFAQs />
      {/* <Stories /> */}
      <HelpSupport />
      <FullLengthSlider
        className={PUBLIC_SECTION_GAP_CLASS}
        itemGapClassName={PUBLIC_BROWSE_SLIDER_ITEM_GAP_CLASS}
        labelClassName={PUBLIC_SLIDER_IMAGE_TO_LABEL_CLASS}
      />
    </>
  );
};

export default BusinessSupport;
